import styled from 'styled-components';
import getAcaraColors from 'styleVariables/getAcaraColors';

export default styled.div`
  top: 1px;
  position: absolute;
  right: 1px;
  height: calc(100% - 2px);
  padding: 1.5rem;
  color: ${getAcaraColors('light').secondaryText};
  cursor: pointer;
  background: #fff;
  border-left: 1px solid ${getAcaraColors('light').borderColor};
  
  &:hover {
    color: #000;
  }
`;
